import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Coa4 from "../../../containers/modules/accounting/coa4";

export default function Coa4Route(props) {
  const { authUser } = props;
  return (
    <Route
      path="coa4"
      index
      element={
        <AccessControl
          name={"Coa4 List"}
          auth={authUser}
          component={() => <Coa4 />}
        />
      }
    />
  );
}
